import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-background-200/50 rounded-full">
          <i className="ri-error-warning-line text-4xl text-foreground-400"></i>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-foreground-900 mb-4">
          404
        </h1>
        <p className="text-xl text-foreground-600 mb-2">
          {t('not_found_title')}
        </p>
        <p className="text-base text-foreground-500 mb-8">
          {t('not_found_text')}
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-8 py-3 bg-primary-500 text-white font-medium rounded-xl hover:bg-primary-600 transition-all whitespace-nowrap"
        >
          {t('not_found_back')}
        </button>
      </div>
    </div>
  );
}